import React from 'react';
import { HeartCrackIcon, SparklesIcon, TrendingUpIcon, MessageSquareIcon } from 'lucide-react';
export function PainAndHope() {
  const pains = ['Sientes que tu tiempo no te pertenece', 'Ves oportunidades pero no sabes cómo aprovecharlas', 'Quieres más para tu familia pero el camino no está claro'];
  return <section className="w-full px-4 py-12 md:py-24 bg-gradient-to-b from-dark via-darkGray to-dark relative overflow-hidden" data-id="element-199">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-primary/5 via-transparent to-transparent pointer-events-none" data-id="element-200"></div>
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-201">
        <div className="text-center mb-10 md:mb-12" data-id="element-202">
          <div className="flex items-center justify-center gap-2 md:gap-3 mb-6 md:mb-8" data-id="element-203">
            <HeartCrackIcon className="w-7 h-7 md:w-10 md:h-10 text-primary" data-id="element-204" />
            <h2 className="text-[26px] sm:text-[32px] md:text-[40px] lg:text-[56px] font-bold font-poppins text-white tracking-tight uppercase leading-tight" data-id="element-205">
              Reconoce Esta Sensación
            </h2>
          </div>
          <div className="space-y-4 md:space-y-5 mb-8 md:mb-10" data-id="element-206">
            {pains.map((pain, index) => <div key={index} className="bg-gradient-to-r from-lightBg via-white to-lightBg p-5 md:p-6 rounded-2xl border-2 border-lightBorder shadow-lg transform hover:scale-105 transition-all duration-300" data-id="element-207">
                <p className="text-[15px] md:text-[18px] font-inter text-textDark leading-relaxed font-medium inline-flex items-start gap-2" data-id="element-208">
                  <MessageSquareIcon className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-209" />
                  {pain}
                </p>
              </div>)}
          </div>
          <div className="bg-gradient-to-br from-lightBg via-white to-lightBg p-6 md:p-12 rounded-3xl border-4 border-primary shadow-2xl relative overflow-hidden" data-id="element-210">
            <div className="absolute top-0 right-0 w-40 h-40 bg-primary/5 rounded-full blur-3xl" data-id="element-211"></div>
            <p className="text-[17px] md:text-[22px] font-inter text-textDark mb-5 md:mb-6 leading-relaxed relative z-10" data-id="element-212">
              Yo también viví así.
            </p>
            <p className="text-[22px] sm:text-[28px] md:text-[32px] lg:text-[42px] font-bold font-poppins text-primary mb-5 md:mb-6 tracking-tight leading-[1.15] relative z-10 px-2" data-id="element-213">
              Hasta que descubrí que no necesitaba trabajar más duro...
            </p>
            <p className="text-[18px] md:text-[24px] font-bold font-inter text-textDark relative z-10" data-id="element-214">
              Necesitaba aprender diferente.
            </p>
          </div>
        </div>
        <div className="text-center space-y-5 md:space-y-6 mt-10 md:mt-12" data-id="element-215">
          <div className="flex items-center justify-center gap-2 md:gap-3 mb-5 md:mb-6" data-id="element-216">
            <SparklesIcon className="w-7 h-7 md:w-10 md:h-10 text-primary animate-pulse" data-id="element-217" />
            <h3 className="text-[24px] sm:text-[28px] md:text-[36px] font-bold font-poppins text-white tracking-tight uppercase leading-tight" data-id="element-218">
              Pero Hay Esperanza
            </h3>
          </div>
          <div className="bg-lightBg/5 backdrop-blur-sm p-6 md:p-8 rounded-3xl border-2 border-primary/30" data-id="element-219">
            <p className="text-[17px] md:text-[22px] font-inter text-textGray leading-relaxed mb-4" data-id="element-220">
              Porque mientras lees esto...{' '}
              <span className="text-primary font-bold block mt-2 text-[19px] md:text-[24px]" data-id="element-221">
                ya estás más cerca de lo que crees.
              </span>
            </p>
          </div>
          <p className="text-[15px] md:text-[18px] font-inter text-white/80 italic" data-id="element-222">
            El primer paso es saber que existe un camino diferente.
          </p>
        </div>
      </div>
    </section>;
}